import axios from 'axios';
import { URLEndpoints } from '../../constants/urlConstants';
const baseUrl=process.env.REACT_APP_NODEJS_SERVER_URL
export const getOptionalAuthHeaders = () => {
    const token = String(localStorage.getItem("accessToken") || "").trim();
    if (!token) return {};

    return {
        accessToken: token,
        Authorization: token.startsWith("Bearer ")
            ? token
            : `Bearer ${token}`,
    };
}
export const getClientContacts=async(id, options = {})=>{
    try {
       const res= await axios.get(`${baseUrl}/${URLEndpoints.clientContacts}/${id}`, {
        ...options,
        headers: {
            ...getOptionalAuthHeaders(),
            ...(options?.headers || {}),
        },
       })
       return res
    } catch (error) {
        console.log(error)
    }
}

export const getCustomerDetails=async(id, options = {})=>{
    try {
       const res= await axios.get(`${baseUrl}/${URLEndpoints.customers}/${id}`, {
        ...options,
        headers: {
            ...getOptionalAuthHeaders(),
            ...(options?.headers || {}),
        },
       })
       const payload = res?.data;
       return payload?.customer ? payload : { customer: payload };
    } catch (error) {
        console.log(error)
    }
}

export const getCustomerDetailsForOrder = async (id, orderId, options = {}) => {
    try {
       const res = await axios.get(`${baseUrl}/customers/get-customer/${id}`, {
        ...options,
        params: {
            ...(options?.params || {}),
            ...(orderId ? { orderId } : {}),
        },
        headers: {
            ...getOptionalAuthHeaders(),
            ...(options?.headers || {}),
        },
       })
       return res?.data || { customer: null, notes: [] }
    } catch (error) {
        console.log(error)
    }
}

export const fetchCustomerTermChangeRequests = async (id, options = {}) => {
    return axios.get(`${baseUrl}/customers/${id}/term-change-requests`, {
        ...options,
        headers: {
            ...getOptionalAuthHeaders(),
            ...(options?.headers || {}),
        },
    });
}

export const createCustomerTermChangeRequest = async (id, payload, options = {}) => {
    return axios.post(`${baseUrl}/customers/${id}/term-change-requests`, payload, {
        ...options,
        headers: {
            ...getOptionalAuthHeaders(),
            ...(options?.headers || {}),
        },
    });
}

export const requestCustomerConversion = async (id, options = {}) => {
    return axios.post(`${baseUrl}/customers/convert-to-customer/${id}`, {}, {
        ...options,
        headers: {
            ...getOptionalAuthHeaders(),
            ...(options?.headers || {}),
        },
    });
}

export const createCustomerContact = async (id, payload, options = {}) => {
    return axios.post(`${baseUrl}/customers/${id}/client-contacts`, payload, {
        ...options,
        headers: {
            ...getOptionalAuthHeaders(),
            ...(options?.headers || {}),
        },
    });
}
